var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVewideaIconfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 1.33398H4.00008C3.64646 1.33398 3.30732 1.47446 3.05727 1.72451C2.80722 1.97456 2.66675 2.3137 2.66675 2.66732V13.334C2.66675 13.6876 2.80722 14.0267 3.05727 14.2768C3.30732 14.5268 3.64646 14.6673 4.00008 14.6673H12.0001C12.3537 14.6673 12.6928 14.5268 12.9429 14.2768C13.1929 14.0267 13.3334 13.6876 13.3334 13.334V6.00065M8.66675 1.33398L13.3334 6.00065M8.66675 1.33398V6.00065H13.3334",
    stroke: "#8231A7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVewideaIconfile);
export default __webpack_public_path__ + "static/media/vewidea-iconfile.9afa8cf873924ffd257d0e083d7f1a53.svg";
export { ForwardRef as ReactComponent };